/** @jsx jsx */
import { jsx, css } from '@emotion/core'
import styled from '@emotion/styled'
import React, { useState, useEffect, useContext } from 'react'
import * as api from 'api/pgads'
import { Button } from 'antd'
import { Content, CriteriaRow, FullHeightSizer, Title } from 'core/screen-util'

import WSAccessEntry from './WSAccessEntry'
import WSAccessEditPrompt from './WSAccessEditPrompt'
import { ErrorContext, SpinContext } from 'context'
import { connect } from 'react-redux'
import { getApiTargetInfo } from 'core'

const Container = styled.div`
  padding: 0em;
`

const WebServiceAccess = ({ targetInfo }) => {
  const [data, setData] = useState([])
  const [promptNew, setPromptNew] = useState(null)
  // const [setError, errorModal] = useErrorModal()
  const { setError } = useContext(ErrorContext)
  const { setSpinning, spinning } = useContext(SpinContext)

  const retrieveData = _ => {
    setSpinning(true)
    api.getWSAccessInfo(targetInfo).fork(setError, d => {
      setSpinning(false)
      setData(d)
    })
  }

  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(() => retrieveData(), [])

  const createRemoveTask = rData => {
    setSpinning(true)
    api
      .deleteWSAccessInfo(targetInfo)([rData])
      .fork(setError, () => {
        setSpinning(false)
        retrieveData()
      })
  }

  const createSaveTask = data => {
    setSpinning(true)
    api
      .saveWSAccessInfo(targetInfo)([data])
      .fork(setError, () => {
        setSpinning(false)
        setPromptNew(false)
        retrieveData()
      })
  }

  const createUpdateActiveStatusTask = tData => {
    setSpinning(true)
    api
      .activeStatusUpdateInfo(targetInfo)([tData])
      .fork(setError, () => {
        setSpinning(false)
        retrieveData()
      })
  }

  return (
    <div
      css={{
        backgroundColor: '#f0f2f5',
        marginLeft: '20px',
        marginRight: '20px',
      }}
    >
      <Container>
        <CriteriaRow css={{ marginBottom: '1px' }}>
          <Title
            style={{
              marginRight: '15px',
              marginBottom: '5px',
            }}
          >
            WebService Access
          </Title>
          <Button
            css={{ marginLeft: '10px' }}
            onClick={() => retrieveData()}
            loading={spinning}
            type="primary"
          >
            Retrieve
          </Button>
          <Button
            css={{ marginLeft: '10px' }}
            onClick={() => setPromptNew(true)}
            type="primary"
          >
            Create New WebService Access
          </Button>
        </CriteriaRow>
        <FullHeightSizer heightOffset={240}>
          {({ width, height }) => (
            <Content
              style={{
                height: height - 10,
                width: width - 10,
                padding: '10px',
              }}
            >
              <WSAccessEntry
                createRemoveTask={createRemoveTask}
                // key={p.serviceName + p.endpointName + 'sub' + i}
                key="sub"
                index={1}
                createSaveTask={createSaveTask}
                createUpdateActiveStatusTask={createUpdateActiveStatusTask}
                data={data}
                retrieveData={retrieveData}
                height={height - 20}
                width={width - 20}
              />
            </Content>
          )}
        </FullHeightSizer>

        {promptNew && (
          <WSAccessEditPrompt
            getSaveTask={createSaveTask}
            mode="new"
            close={setPromptNew}
          />
        )}
      </Container>
    </div>
  )
}

const mapStateToProps = state => ({
  targetInfo: getApiTargetInfo(state),
})

export default connect(mapStateToProps)(WebServiceAccess)
